module.exports = __webpack_public_path__ + "img/support-ticket-app.7bc0d807.png";